import { z } from "zod";

import { chatMessageSchema, chatSchema } from "../commons/chat";

// SOCKET POST /chat
export const sendMessageBodySchema = z.object({
  chatId: z.string().optional(),
  message: z.string(),
});

export type SendMessageBody = z.infer<typeof sendMessageBodySchema>;

export const sendMessageRequestSchema = z.object({
  body: sendMessageBodySchema,
});

export const sendMessageSocketResponseSchema = chatMessageSchema;

export type SendMessageSocketResponse = z.infer<
  typeof sendMessageSocketResponseSchema
>;

//  GET /chat/:chatId
export const getChatParamsSchema = z.object({
  chatId: z.string(),
});

export type GetChatParams = z.infer<typeof getChatParamsSchema>;

export const getChatRequestSchema = z.object({
  params: getChatParamsSchema,
});

export type GetChatRequest = z.infer<typeof getChatRequestSchema>;

export const getChatResponseSchema = chatSchema;

export type GetChatResponse = z.infer<typeof getChatResponseSchema>;

//  GET /chat
export const listChatsResponseSchema = z.array(
  z.object({
    _id: z.string(),
    topic: z.string().optional(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
  }),
);

export type ListChatsResponse = z.infer<typeof listChatsResponseSchema>;

// PUT /chat/:chatId
export const updateChatParamsSchema = z.object({
  chatId: z.string(),
});

export type UpdateChatParams = z.infer<typeof updateChatParamsSchema>;

export const updateChatBodySchema = z.object({
  topic: z.string().optional(),
});

export type UpdateChatBody = z.infer<typeof updateChatBodySchema>;

export const updateChatRequestSchema = z.object({
  body: updateChatBodySchema,
  params: updateChatParamsSchema,
});

export type UpdateChatRequest = z.infer<typeof updateChatRequestSchema>;

export const updateChatResponseSchema = chatSchema;

export type UpdateChatResponse = z.infer<typeof updateChatResponseSchema>;

// DELETE /chat/:chatId
export const deleteChatParamsSchema = z.object({
  chatId: z.string(),
});

export type DeleteChatParams = z.infer<typeof deleteChatParamsSchema>;

export const deleteChatRequestSchema = z.object({
  params: deleteChatParamsSchema,
});
